import React, { Component, createRef } from 'react';
import withErrorCatcher from '../Common/withErrorCatcher.js'
import { Chip, Grid, withStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
// import HighlightOffTwoToneIcon from '@material-ui/icons/HighlightOffTwoTone';
import CancelIcon from '../../../ui/components/Common/Icons/SearchIcons/CancelIcon'
// Apply some reset
const styles = theme => ({
  wrapper: {
    fontFamily: theme.typography.fontFamily,
    position: 'relative',
    borderRadius: 4,
    height:32,
    minWidth: theme.constants.searchInputWidth,
    width: theme.constants.searchInputWidth,
    '& $input': {
      transition: theme.transitions.create('width'),
    },
    flexWrap: 'unset',
    color: '#ffffff'
  },
  search: {
    paddingLeft: 12,
    paddingRight: 7,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'inherit',
    "&:hover": {
      backgroundColor: 'transparent',
    }
  },
  input: {
    maxWidth: theme.constants.searchInputWidth - 100,
    font: 'inherit',
    marginLeft: 3,
    padding: 0,
    border: 0,
    display: 'block',
    verticalAlign: 'middle',
    whiteSpace: 'normal',
    background: 'none',
    margin: 0, // Reset for Safari
    color: 'inherit',
    height: 32,
    "fontFamily": '"Rubik"',
    "fontSize": "14px",
    "fontWeight": "normal",
    "fontStretch": "normal",
    "fontStyle": "normal",
    "lineHeight": "1.75",
    "letterSpacing": "0.5px",
    '&:focus': {
      outline: 0,
    },
    '&::placeholder': {
      "fontFamily": '"Rubik"',
      "fontSize": "14px",
      "fontWeight": "normal",
      "fontStretch": "normal",
      "fontStyle": "normal",
      "lineHeight": "1.75",
      "letterSpacing": "0.5px",
      "color": 'rgba(255, 255, 255, 0.5)',
    }
  },
  chipGroup: { 
    cursor: "pointer" ,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 1,
    marginRight: 2,
    height: 24,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    borderRadius: 6,
   
  },
  chipMy: {
    cursor: "pointer" ,
    marginBottom: 1,
    marginRight: 2,
    height: 24,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    borderRadius: 6,
  },
  chipText: {
    // marginBottom: -2,
    fontFamily: 'Rubik', 
    fontSize: 14, 
    letterSpacing: 0.4,
    color: theme.customColors.primary.main, 
    lineHeight: '16px',
  },
  cancelIconContainer: {
    width: 15, 
    height: 15,
    marginLeft: -10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
});


class SearchInput extends Component {
  inputRef = createRef()

  searchNavigationListener = (e) => {
    const { setIsFocused } = this.props;

    const ignoreElement = document.getElementById('search-navigation-dialog');
    const isClickInsideElement = ignoreElement.contains(e.target);

    if (!isClickInsideElement && this.inputRef.current) {
      this.inputRef.current.blur()
      setIsFocused(false)
      return;
    }
    return false;
  }

  launchpadNavigationListener = (e) => {
    const { dispatch } = this.props;

    const ignoreElement = document.getElementById('launchpad-navigation-dialog');
    const isClickInsideElement = ignoreElement.contains(e.target);

    if (!isClickInsideElement) {
      dispatch({ type: 'BLUR_LAUNCHPAD' })
      return;
    }
    return false;
  }
  userNavigationListener = (e) => {
    const { dispatch } = this.props;

    const ignoreElement = document.getElementById('user-navigation-dialog');
    const isClickInsideElement = ignoreElement.contains(e.target);

    if (!isClickInsideElement) {
      dispatch({ type: 'BLUR_USER_MODAL' })
      return;
    }
    return false;
  }
  chatsNavigationListener = (e) => {
    const { dispatch } = this.props;

    const ignoreElement = document.getElementById('chats-navigation-dialog');
    const isClickInsideElement = ignoreElement.contains(e.target);

    if (!isClickInsideElement) {
      dispatch({ type: 'BLUR_CHATS_MODAL' })
      return;
    }
    return false;
  }
  notificationsNavigationListener = (e) => {
    const { dispatch } = this.props;

    const ignoreElement = document.getElementById('notifications-navigation-dialog');
    const isClickInsideElement = ignoreElement.contains(e.target);

    if (!isClickInsideElement) {
      dispatch({ type: 'BLUR_NOTIFICATIONS_MODAL' })
      return;
    }
    return false;
  }

  componentDidMount() {
    // const Element = document.getElementById('search-navigation-wrapper');
    // if(!Element) return;

    // Element.addEventListener('click', this.searchNavigationListener)
    const Search = document.getElementById('search-navigation-wrapper');
    const Launchpad = document.getElementById('launchpad-navigation-wrapper');
    const UserModal = document.getElementById('user-navigation-wrapper');
    const NotificationsModal = document.getElementById('notifications-navigation-wrapper');
    const ChatsModal = document.getElementById('chats-navigation-wrapper');

    !!Search && Search.addEventListener('click', this.searchNavigationListener)
    !!Launchpad && Launchpad.addEventListener('click', this.launchpadNavigationListener)
    !!UserModal && UserModal.addEventListener('click', this.userNavigationListener)
    !!NotificationsModal && NotificationsModal.addEventListener('click', this.notificationsNavigationListener)
    !!ChatsModal && ChatsModal.addEventListener('click', this.chatsNavigationListener)
  }

  componentDidUpdate(prevProps){
    const {isFocused, dispatch} = this.props
    const {prevIsFocused} = prevProps
    if(prevIsFocused === isFocused) return
    
    isFocused ? 
      this.inputRef.current.focus() :
      this.inputRef.current.blur()
  }

  componentWillUnmount() {
    // const Element = document.getElementById('search-navigation-wrapper');
    // if(!Element) return
    // Element.removeEventListener('click', this.searchNavigationListener)
    const Search = document.getElementById('search-navigation-wrapper');
    const Launchpad = document.getElementById('launchpad-navigation-wrapper');
    const UserModal = document.getElementById('user-navigation-wrapper');
    const NotificationsModal = document.getElementById('notifications-navigation-wrapper');
    const ChatsModal = document.getElementById('chats-navigation-wrapper');

    Search && Search.removeEventListener('click', this.searchNavigationListener)
    Launchpad && Launchpad.removeEventListener('click', this.launchpadNavigationListener)
    UserModal && UserModal.removeEventListener('click', this.userNavigationListener)
    NotificationsModal && NotificationsModal.removeEventListener('click', this.notificationsNavigationListener)
    !!ChatsModal && ChatsModal.removeEventListener('click', this.chatsNavigationListener)
  }

  onFocus = () => {
    const {setIsFocused} = this.props;
    setIsFocused(true);
  }
  
  onOpenGroupsNavigation = () => {
    this.props.dispatch({
      type: 'SEARCH_QUERY', query: {query: '/', isFocused: true}
    })
  }

  render() {
    const { classes, onSearch, group, onRemoveChip, isMyPage, t,theme  } = this.props;

    return <Grid container className={classes.wrapper} alignItems='center'>
      <Grid item>
        <IconButton disableRipple={true} className={classes.search} onClick={onSearch} aria-label="Search">
          <img alt="search" src={"/resources/search.svg"}  />
        </IconButton>
      </Grid>
      {group ? <Grid item >
        <Chip onClick={this.onOpenGroupsNavigation} deleteIcon={<div data-intrcm-id="searchInput_lycmvswp" className={classes.cancelIconContainer}><CancelIcon color={theme.primary.b500} /></div>} label={group.label} classes={{ label: classes.chipText }} className={classes.chipGroup} onDelete={onRemoveChip}  />
      </Grid> : null}
      {isMyPage ? <Grid item>
        <Chip deleteIcon={<div data-intrcm-id="searchInput_2z1v4qhs" className={classes.cancelIconContainer}><CancelIcon color={theme.primary.b500} /></div>} label={t('My Page')}    classes={{ label: classes.chipText }} className={classes.chipMy}   onDelete={onRemoveChip} />
      </Grid> : null}
      <Grid item>
        <input autoComplete="off" ref={ref => (this.inputRef.current = ref)} onFocusCapture={this.onFocus} id="docsearch-input" {...this.props} className={classes.input} style={group?{width:300}:{width:510}} />
      </Grid>
    </Grid>

  }

}

const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(
  withStyles(styles, { withTheme: true }), 
  withTranslation('search'),
  connect(
      null,
      mapDispatchToProps,
  )
)(SearchInput);